import { useTranslation } from "next-i18next";
import { ReactNode } from "react";

import { Background } from "@baseComponents/Background";
import { ArticleContainer, ArticleContent } from "@baseComponents/css";
import { Menu } from "@components/menu";
import { PageMetadata, PageMetadataProps } from "@components/PageMetadata";

import Footer from "../footer";

interface PortfolioLayoutProps extends PageMetadataProps {
  header: ReactNode;
  children?: ReactNode;
}

function PortfolioLayoutBody({
  header,
  children,
  title: titleKey,
  description: descriptionKey,
}: PortfolioLayoutProps) {
  const { t } = useTranslation();

  return (
    <>
      <PageMetadata title={t(titleKey)} description={t(descriptionKey)} />

      <Background withBlurBoxes />

      <Menu />

      <ArticleContainer maxWidth="desktopXl">
        {header}

        <ArticleContent>{children}</ArticleContent>
      </ArticleContainer>

      <Footer />
    </>
  );
}

export const PortfolioLayout = ({
  children,
  ...rest
}: PortfolioLayoutProps) => {
  return <PortfolioLayoutBody {...rest}>{children}</PortfolioLayoutBody>;
};
